import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function headerInit() {

  let siteNavMobileButton = document.querySelector('#siteNavMobileButton');

  ScrollTrigger.create({
    start: 'top -115',
    end: 99999,
    toggleClass: { className: 'is-visible', targets: siteNavMobileButton }
  });

  ScrollTrigger.refresh();
}
